module.exports = __webpack_public_path__ + "assets/img/WechatIMG68.00d630aa.png";